import { render } from "./SubHeader.vue?vue&type=template&id=41c2b0b4"
import script from "./SubHeader.vue?vue&type=script&lang=js"
export * from "./SubHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__